import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearTaskDetails,
  getTaskDetails,
  getSubTasksDetails,
  SubTaskDataAdd,
} from "../../API/store/actions/tasks";
import TaskComments from "./taskComments";
import TaskDetails from "./taskDetails";
import { useParams } from "react-router-dom";
import Loading from "../reusableComponents/loadingScreens";
import { ScrollToTop } from "../../algorithms";
import TaskDetailsCard from "./taskDetailsCard";
import { customStyle } from "../../algorithms/styleDirection";

const TaskDetailsIndex = ({ userToken }) => {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions(),
  );
  const [displayComments, setDisplayComments] = useState({
    display: false,
    id: null,
    content: [],
    owner: {},
  });

  const [procAdded, setProcAdded] = useState(false);

  const { id } = useParams();
  const dispatch = useDispatch();
  const TasksDetails = useSelector((state) => state.tasks.getTaskDetails);
  const SubTasksDetails = useSelector(
    (state) => state.tasks.getSubTasksDetails,
  );
  const communityId = useSelector((state) => state.community.communityId?.id);

  useEffect(() => {
    dispatch(SubTaskDataAdd(communityId, userToken));
    dispatch(getTaskDetails(parseInt(id), userToken));
    dispatch(getSubTasksDetails(parseInt(id), userToken));

    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener("resize", handleResize);
    ScrollToTop();
    return () => {
      dispatch(clearTaskDetails());
      window.removeEventListener("resize", handleResize);
    };
  }, [windowDimensions, procAdded]);
  if (TasksDetails?.data)
    return (
      <>
        <div className="d-flex flex-column align-items-center align-items-sm-start col-xl-9 col">
          <TaskDetails
            TasksDetails={TasksDetails}
            commentsUnderProcedure={
              windowDimensions.width <= 1200 ? true : false
            }
            proceduresUnderSubTasks={
              // windowDimensions.width <= 1200 ? true : false
              true
            }
            displayComments={displayComments}
            setDisplayComments={setDisplayComments}
            setProcAdded={setProcAdded}
            procAdded={procAdded}
            subTaskProcedures={SubTasksDetails?.data?.tasks}
          />
        </div>
        {/*
        {windowDimensions.width > 1200 ? (
          <div
            id="scroll"
            className={`scroll d-flex flex-lg-column col-4  ${customStyle(
              "fixedClass"
            )} overflow-auto mt-3`}
            style={{
              height: "85%",
            }}
          >
            <TaskDetailsCard
              displayComments={displayComments}
              setDisplayComments={setDisplayComments}
              procedures={TasksDetails?.data?.procedure}
              commentsUnderProcedure={true}
              setProcAdded={setProcAdded}
              procAdded={procAdded}
            />
          </div>
        ) : null} */}
        {/* {windowDimensions.width > 1200 && displayComments.display ? (
          // <div
          //   id="scroll"
          //   className={`scroll d-flex flex-lg-column col-3  ${customStyle(
          //     "fixedClass"
          //   )} overflow-auto mt-3`}
          //   style={{
          //     height: "85%",
          //   }}
          // >
          <>
            <TaskComments
              TasksDetails={TasksDetails}
              displayComments={displayComments}
              setDisplayComments={setDisplayComments}
            />
          </>
        ) : null} */}
      </>
    );
  else
    return (
      <div>
        <Loading />
      </div>
    );
};

export default TaskDetailsIndex;

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}
